import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap';
import { AiFillEdit, AiFillFilter } from 'react-icons/ai';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getTips, onSearchData, onSaveTip, getTipByDate, onFinishTip, onReverseTip } from '../../Redux/tipDuck';
import { toogleLoader } from '../../Redux/alertDuck';
import ItemTip from './item.tip';
import TemplateMenu from '../../template/menu.template'
import { formatNumber } from '../../utils';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { FaEdit } from 'react-icons/fa';

const API_URL = process.env.REACT_APP_API_URL

const TipsPage = ({ data, onSearchData, fetching_search, onSaveTip, getTipByDate,
    fetching_current, row, toogleLoader, fetching_create, onFinishTip, fetching_finish,
    pdfs, onReverseTip
}) => {

    const [listWorker, setListWorker] = useState([]);
    const [allowed, setAllowed] = useState(0);
    const [discount, setDiscount] = useState(0);
    const [total, setTotal] = useState(0);
    const [dataTip, setDataTip] = useState({ id: 0 });
    const [tip, setTip] = useState(0);
    const [hasTip, setHasTip] = useState(false);
    const [isEnable, setIsEnable] = useState(false);
    const [hasDiscount, setHasDiscount] = useState(false);

    useEffect(() => {
        onSearchData()
        getTipByDate()
    }, [])

    useEffect(() => {
        if (fetching_search === 2) {
            let { workers, allowed, tips } = data
            setTotal(allowed)
            setAllowed(allowed)
            setTip(tips)
            let total_points = 7 * workers.length

            let points_worker_days = 7 / 30 * 30

            let percent = (points_worker_days * 100) / total_points

            let total = ((percent * allowed - discount) / 100)


            // d.total = ((d.percent * (allowed - discount)) / 100);




            let list = workers.map(item => ({
                ...item, worker_days: 30,
                assign_point: 7,
                points_worker_days,
                percent,
                discount: 0,
                total
            }))

            console.log('list', list);

            setListWorker(list)
        }
    }, [fetching_search])

    useEffect(() => {
        if (fetching_create === 2) {
            window.location.reload()
            toogleLoader(false)
        }
    }, [fetching_create])

    useEffect(() => {
        if (fetching_current === 2 && fetching_search === 2) {
            let { workers, allowed } = data
            setIsEnable(true)

            if (row !== null) {
                setIsEnable(false)
                let { discount } = row

                let { detail } = row
                setTotal(parseFloat(allowed) - parseFloat(discount))
                setHasTip(true)
                setDataTip(row)
                setDiscount(discount)

                let total = detail.reduce((a, b) => a + (parseInt(b.points) / 30) * b.days, 0)

                let _filter = workers.map(d => {
                    detail.forEach(element => {
                        if (element.worker_id === d.id) {
                            d.assign_point = element.points;
                            d.worker_days = element.days;
                            d.points_worker_days = (element.points / 30 * element.days)
                            d.percent = (d.points_worker_days * 100) / total
                            d.total = ((d.percent * (allowed - discount)) / 100);
                        }
                    });
                    return d
                })
                setListWorker(_filter)
            }

        }
    }, [fetching_current, fetching_search])

    useEffect(() => {
        if (fetching_finish === 2) {
            toogleLoader(false)
            console.log(window.open(`${API_URL}/${pdfs.pdf}`, '_blank'));
        }
    }, [fetching_finish])

    const updateRow = (row) => {
        let _filter = listWorker.map(d => {
            if (d.id === row.id) {
                d.points_worker_days = (d.assign_point / 30 * d.worker_days)
                d.percent = d.points_worker_days * 100
            }
            return d
        })

        let total = listWorker.reduce((a, b) => a + b.points_worker_days, 0)

        _filter = listWorker.map(d => {
            d.points_worker_days = (d.assign_point / 30 * d.worker_days)
            d.percent = (d.points_worker_days * 100) / total
            d.total = ((d.percent * (allowed - parseFloat(discount))) / 100);
            return d
        });

        setListWorker(_filter)
    }

    const updateRowMonth = (row) => {

        let _filter = listWorker.map(d => {
            if (d.id === row.id) {
                d.worker_days = row.worker_days
                d.points_worker_days = (d.assign_point / 30 * d.worker_days)
            }
            return d
        })

        let total = listWorker.reduce((a, b) => a + b.points_worker_days, 0)

        _filter = listWorker.map(d => {
            d.points_worker_days = (d.assign_point / 30 * d.worker_days)
            d.percent = (d.points_worker_days * 100) / total
            d.total = ((d.percent * (allowed - parseFloat(discount))) / 100);
            return d
        });
        setListWorker(_filter)
    }

    const onSaveTipForm = () => {
        toogleLoader(true)
        onSaveTip(tip, allowed, listWorker, discount)
    }

    const onFinish = () => {
        if (window.confirm('¿Deseas finalizar el pago de Propina?')) {
            toogleLoader(true)
            onFinishTip(dataTip.id)
        }
    }

    const onReverse = () => {
        if (window.confirm('¿Deseas reversar el pago?')) {
            toogleLoader(true)
            console.log("llego")
            onReverseTip(dataTip.id)
        }
    }




    return (<TemplateMenu>
        <Container fluid>
            <Row className="my-4">
                <Col lg={3} md={4}>
                    <h4 className="font-title pt-3">LIQUIDACION PROPINAS</h4>
                </Col>
                <Col lg={7}>
                    <Row>
                        <Col lg={4}>Total Recaudado</Col>
                        <Col>{formatNumber(tip)}</Col>
                    </Row>

                    <Row>
                        <Col lg={4}>Total Permitido</Col>
                        <Col>{formatNumber(parseFloat(allowed))}</Col>
                    </Row>
                    <Row>
                        <Col lg={4}>Descuento</Col>
                        <Col>
                            {hasDiscount === true ? <Row>
                                <Col>
                                    <input type='number' className='form-control' value={discount} onChange={(e) => setDiscount(e.target.value)} />
                                </Col>
                                <Col>
                                    <button className='btn btn-sm btn-danger mx-2' onClick={() => setHasDiscount(false)}>Cerrar</button>
                                    <button className='btn btn-sm btn-success' onClick={() => setHasDiscount(false)}>Guardar</button>
                                </Col>
                            </Row> : <>
                                {formatNumber(discount)}

                                {dataTip.id === 0 &&
                                    <AiFillEdit className='cursor-pointer' onClick={() => setHasDiscount(!hasDiscount)} />}

                            </>}
                        </Col>
                    </Row>
                    <Row className='border-top'>
                        <Col lg={4}>Total Repartir</Col>
                        <Col>{formatNumber(parseFloat(allowed) - parseFloat(discount))}</Col>
                    </Row>
                    <Row>
                        <Col lg={4}>Total Puntos</Col>
                        <Col>{formatNumber(listWorker.reduce((a, b) => a + parseFloat(b.assign_point), 0))}</Col>
                    </Row>
                    <Row>
                        <Col>Valor del Punto</Col>
                    </Row>
                </Col>
                <Col className='d-flex align-items-center'>
                    {dataTip.id === 0 ?
                        <button className='btn btn-sm btn-info' onClick={onSaveTipForm}>Guardar</button>
                        :
                        <>
                            <button className='btn btn-sm btn-danger mx-1' onClick={onReverse}>Reversar</button>
                            <button className='btn btn-sm btn-success' onClick={onFinish}>Finalizar</button>
                        </>}

                </Col>

            </Row>
            <Row>
                <Col lg={12}>
                    <table className="table table-sm table-bordered">
                        <thead className="thead-dark">
                            <tr>
                                <th>Nombre</th>
                                <th>Cedula</th>
                                <th>Cargo</th>
                                <th>PUNTOS ASIGNADOS POR CARGO</th>
                                <th>PUNTOS X DIAS TRABAJADOS</th>
                                <th>DIAS TRABAJADOS</th>
                                <th>PORCENTAJE</th>
                                <th>VALOR A PAGAR</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(listWorker.length > 0) ? listWorker.map(row =>
                                <ItemTip item={row} key={row.id}
                                    updateRow={updateRow}
                                    updateRowMonth={updateRowMonth}
                                    isEnable={isEnable}
                                />) : <tr><td colSpan={14} className="text-center">No Tienes Registros</td></tr>}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan={3}>TOTAL</th>
                                <th>{formatNumber(listWorker.reduce((a, b) => a + parseFloat(b.assign_point), 0))}</th>
                                <th>{formatNumber(listWorker.reduce((a, b) => a + parseFloat(b.points_worker_days), 0))}</th>
                                <th></th>
                                <th className='text-right'>{formatNumber(listWorker.reduce((a, b) => a + parseFloat(b.percent), 0))}</th>
                                <th className='text-right'>{formatNumber(listWorker.reduce((a, b) => a + parseFloat(b.total), 0))}</th>
                            </tr>
                        </tfoot>
                    </table>
                </Col>
            </Row >
        </Container>
    </TemplateMenu>
    )
}

const mapsState = (props) => {
    let { tip } = props

    return {
        fetching_search: tip.fetching_search,
        fetching_current: tip.fetching_current,
        fetching_create: tip.fetching_create,
        fetching_finish: tip.fetching_finish,
        pdfs: tip.pdfs,
        data: tip.data,
        row: tip.row,
    }
}

export default connect(mapsState, {
    getTips, onSearchData, onSaveTip, getTipByDate, toogleLoader,
    onFinishTip, onReverseTip
})(TipsPage);